import { mapMutations, mapState } from 'vuex'
import { throttle } from '@/utils'

export default {
  data () {
    return {
      currentScrollValue: 0,
      colorOnScroll: 65,
      throttledMethod: () => {},
    }
  },
  computed: {
    ...mapState({
      scrolled: ({ scrolled }) => scrolled,
    }),
  },
  created () {
    this.throttledMethod = throttle(() => {
      this.handleScroll()
    }, 200)

    document.addEventListener('scroll', this.throttledMethod)
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.throttledMethod)
  },
  methods: {
    ...mapMutations(['SET_SCROLLED']),
    handleScroll () {
      this.currentScrollValue = (
        document.body.scrollTop ||
        document.documentElement.scrollTop
      )

      const scrolled = (
        this.colorOnScroll > 0 &&
        (this.currentScrollValue > this.colorOnScroll)
      )

      this.SET_SCROLLED({ scrolled })
    },
  },
}
